const alternativasPerguntas = document.querySelectorAll('[data-js="alternativa"]');
const botaoCalcularResultado = document.querySelector('[data-js="botao-calcular-resultado"]');
const perguntasTotais = [...document.querySelectorAll('[data-js="caixa-pergunta"]')].length;

botaoCalcularResultado?.addEventListener("click", calcularResultado);

[...alternativasPerguntas].forEach((item) => {
  item.addEventListener("click", function(e) {
    const caixaTodasAlternativas = item.closest("[data-js='caixa-pergunta']").querySelectorAll("[data-js='alternativa']");
    limpaAlternativas([...caixaTodasAlternativas]);
    item.classList.add("quiz__alternativa--selecionada");
    item.setAttribute("data-selecionado", "selecionado");
    item.closest("[data-js='caixa-pergunta']").classList.add("selecionado");
    checaBotao();
  });
});

function limpaAlternativas(alternativas) {
  alternativas.forEach((item) => {
    item.classList.remove("quiz__alternativa--selecionada");
    item.removeAttribute("data-selecionado");
  });
}

function checaBotao() {
  const alternativasSelecionadas = [...document.querySelectorAll('[data-selecionado="selecionado"]')].length;

  if (alternativasSelecionadas === perguntasTotais) {
    botaoCalcularResultado.classList.remove("block");
  }
}

function calcularResultado() {
  botaoCalcularResultado.classList.add("calculando");
  botaoCalcularResultado.innerHTML = 'Calculando...'

  const alternativasSelecionadas = document.querySelectorAll('[data-selecionado="selecionado"]');
  const alternativasPesos = [];
  
  [...alternativasSelecionadas].forEach((item) => {
    alternativasPesos.push(parseInt(item.getAttribute("data-peso")));
  })

  const pesoTotal = alternativasPesos.reduce((currentTotal, item) => {
    return item + currentTotal;
  });

  if (pesoTotal <= 11) {
    setTimeout(() => {
      window.location = 'quiz-resultado.html?resultadoQuiz=1';
    }, getRandomArbitrary(1, 3) * 1000);
    return;
  }

  if (12 <= pesoTotal && pesoTotal <= 15) {
    setTimeout(() => {
      window.location = 'quiz-resultado.html?resultadoQuiz=2';
    }, getRandomArbitrary(1, 3) * 1000);
    return;
  }

  if (pesoTotal > 15) {
    setTimeout(() => {
      window.location = 'quiz-resultado.html?resultadoQuiz=3';
    }, getRandomArbitrary(1, 3) * 1000);
    return;
  }
}

//https://stackoverflow.com/questions/1527803/generating-random-whole-numbers-in-javascript-in-a-specific-range
function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}